<script setup lang="ts">
interface Props {
  size?: number;
  isLoading?: boolean;
}

withDefaults(defineProps<Props>(), {
  size: 24,
  isLoading: true,
});
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <template v-if="isLoading">
      <g class="spinner spinner__third">
        <circle
          cx="12"
          cy="12"
          r="9.5"
          class="spinner-circle"
        />
      </g>
      <g class="spinner spinner__second">
        <circle
          cx="12"
          cy="12"
          r="9.5"
          class="spinner-circle"
        />
      </g>
      <g class="spinner spinner__first">
        <circle
          cx="12"
          cy="12"
          r="9.5"
          class="spinner-circle"
        />
      </g>
    </template>
    <template v-else>
      <g>
        <circle
          cx="12"
          cy="12"
          r="9.5"
          class="spinner-circle stop"
        />
      </g>
    </template>
  </svg>
</template>
<style lang="scss" scoped>
.spinner-circle {
  stroke-linecap: round;
  fill: none;
  stroke-width: 3;
  stroke-dasharray: 2 150;

  &.stop {
    stroke: var(--color-gray-04-04);
    stroke-dasharray: 40 150;
  }
}
.spinner {
  transform-origin: center;

  &__first {
    animation: spinner-rotate-first 1.2s linear infinite;

    .spinner-circle {
      stroke: #3c8eff;
      animation: spinner-stroke-first 1.2s ease-in-out infinite;
    }
  }
  &__second {
    animation: spinner-rotate-second 1.2s linear infinite;

    .spinner-circle {
      stroke: #546fff;
      animation: spinner-stroke-second 1.2s ease-in-out infinite;
    }
  }
  &__third {
    animation: spinner-rotate-third 1.2s linear infinite;

    .spinner-circle {
      stroke: #6c4fff;
      animation: spinner-stroke-third 1.2s ease-in-out infinite;
    }
  }
}

@keyframes spinner-rotate-first {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes spinner-rotate-second {
  0% {
    transform: rotate(-120deg);
  }
  70% {
    transform: rotate(180deg);
  }
  85% {
    transform: rotate(220deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes spinner-rotate-third {
  0% {
    transform: rotate(0deg);
  }
  70% {
    transform: rotate(140deg);
  }
  85% {
    transform: rotate(200deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes spinner-stroke-first {
  0% {
    stroke-dasharray: 1 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 30 150;
    stroke-dashoffset: -16;
  }
  100% {
    stroke-dasharray: 10 150;
    stroke-dashoffset: -42;
  }
}

@keyframes spinner-stroke-second {
  0% {
    stroke-dasharray: 0 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 10 150;
    stroke-dashoffset: -12;
  }
  100% {
    stroke-dasharray: 4 150;
    stroke-dashoffset: -42;
  }
}

@keyframes spinner-stroke-third {
  0% {
    stroke-dasharray: 0 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 1 150;
    stroke-dashoffset: -12;
  }
  100% {
    stroke-dasharray: 1 150;
    stroke-dashoffset: -42;
  }
}
</style>
